import React from 'react';

import { Translations } from './translationsTypes';

const DEFAULT_VALUE: {
  language: Translations;
  setLanguage: (language: Translations) => void;
  pageDirection: 'rtl' | 'ltr';
} = {
  language: Translations.en,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setLanguage: (language) => {
    return;
  },
  pageDirection: 'ltr',
};
export const TranslationsContext = React.createContext(DEFAULT_VALUE);
